var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    { 'is-multiple': _vm.TfProductSelector.allowMultiple },
    { 'is-active': _vm.isActive },
    { 'is-disabled': _vm.isDisabled },
    { 'is-parent-level': _vm.isParentLevel },
    'btn-product-option'
  ],style:(_vm.inlineStyle),attrs:{"data-test":`select ${_vm.product.label}`},on:{"mouseover":function($event){_vm.hover = true},"mouseout":function($event){_vm.hover = false},"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.product.label)+"\n  "),_vm._t("productOptionAppend",null,{"product":_vm.product})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }